import React, { useState } from 'react'
import SidebarDashboard from '../SidebarDashboard'
import CustomNavbar from '../CustomNavbar'
import { useHistory } from "react-router-dom";
import { Button, Col, Container, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { ResumenEvaluacionPuestoPDF } from './ResumenEvaluacionPuestoPDF';
import moment from 'moment';
import "../../css/resumenEvaluacionEstilo.css";

const ResumenEvaluacionPuesto = ({ }) => {
  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);
  //trae la información de la fila
  const location = useLocation()
  const rowData = location.state.rowData
  console.log('rowData', rowData)

  const history = useHistory();
  const handleResumenClick = () => {
    history.push("/sucesion/matriz-de-evaluación-de-puesto");
  }

  const ColorCriticidad = (criticidad) => {
    switch (criticidad) {
      case 'Baja Criticidad':
        return 'bg-success'
      case 'Media Criticidad':
        return 'bg-warning text-dark'
      case 'Alta Criticidad':
        return 'bg-danger'
      default:
        return 'bg-secondary'
    }
  }

  const criticidadColor = ColorCriticidad(rowData.criticidad_nombre.trim())
  const vulerabilidad = rowData.info_matriz?.find(item => item.tipo_criticidad === "Vulnerabilidad");
  const vulerabilidadProm = vulerabilidad ? vulerabilidad.criticidad_promedio.promedio : 0
  const negocio = rowData.info_matriz?.find(item => item.tipo_criticidad === "Negocio");
  const negocioProm = negocio ? negocio.criticidad_promedio.promedio : 0
  const negocioPos = negocioProm * 20; // 0 a 100
  const vulnerabilidadPos = vulerabilidadProm * 20; // 0 a 100

  const [loadingPrint, setLoadingPrint] = useState(false);

  const htmlToImg = async () => {
    try {
      setLoadingPrint(true);
      const input = document.getElementById("impresion1");
      html2canvas(input, {
        scale: 3
      }).then((canvas) => {
        let imgWidth = 200;
        let imgHeight = (canvas.height * imgWidth) / canvas.width;
        // const pdf = new jsPDF("p", "mm", [215, 354]);
        let pdf = jsPDF("p", "mm", "a4");
        pdf.addImage(canvas, "PNG", 5, 5, imgWidth, imgHeight);

        
        pdf.save("resumen_evaluacion_puesto.pdf");
        // const input2 = document.getElementById("impresion2");
        // html2canvas(input2).then((canvas2) => {
        //   let imgWidth2 = 200;
        //   let imgHeight2 = (canvas2.height * imgWidth) / canvas2.width;
        //   pdf.addPage();
        //   pdf.addImage(canvas2, "PNG", 5, 5, imgWidth2, imgHeight2);

        //const input3 = document.getElementById("impresion3");
        //   html2canvas(input3).then((canvas3) => {
        //     let imgWidth3 = 200;
        //     let imgHeight3 = (canvas3.height * imgWidth) / canvas3.width;
        //     pdf.addPage();
        //     pdf.addImage(canvas3, "PNG", 5, 5, imgWidth3, imgHeight3);
        //     pdf.save("matriz_nueve_cajas.pdf");
        //     setLoadingPrint(false);
        // });
        // });
      });
    } catch (error) {
      console.log(error);
      document.getElementById("prueba").style.display = "none";
      setLoadingPrint(false);
    }
  };

  function convertirPalabraAVertical(palabra) {
    return palabra.split('').join('<br>');
  }
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container-fluid">
          <div className='my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center'>
            <div className='button-and-text-container'>
              <Button
                onClick={handleResumenClick}
                variant='link'
                className='font-weight-bold mr-1 text-dark'
              >
                <i className="material-icons">keyboard_return</i>
              </Button>
              <h4 className='font-weight-bold text-uppercase d-inline'>Resumen de Evaluación de Puesto</h4>
            </div>
            <Button
              variant="light"
              className='btn btn-light rounded-pill'
              onClick={() => {
                htmlToImg();
              }}
            >
              <i className="material-icons">print</i>
            </Button>
          </div>
          <div className='px-2'>
            <hr />
          </div>
          <Container>
            <Row className="align-items-end">
              <Col md={4} lg={5} className="mt-2">
                <span style={{ fontSize: '1rem' }}>Función:</span> <span className="badge badge-pill badge-light" style={{ fontSize: '0.90rem', marginLeft: '4px', whiteSpace: 'normal' }}>{rowData.descriptor[0].list_posicion[0].codigo + ' / ' + rowData.descriptor[0].list_posicion[0].descripcion}</span>
              </Col>
              <Col md={3} lg={3} className="mt-2">
                <span style={{ fontSize: '1rem' }}>Empresa:</span> <span className="badge badge-pill badge-light" style={{ fontSize: '1rem', marginLeft: '4px', whiteSpace: 'normal' }}>{rowData.descriptor[0].list_empresa[0].nombre}</span>
              </Col>
              <Col md={3} lg={3} className="mt-2">
                <span style={{ fontSize: '1rem' }}>Área:</span>  <span className="badge badge-pill badge-light" style={{ fontSize: '1rem', marginLeft: '4px', whiteSpace: 'normal' }}>{rowData.descriptor[0].list_division[0].descripcion}</span>
              </Col>
            </Row>
          </Container>
          <Row className="mx-4">
            <Col md={8}>
              {/* Primer Row */}
              <Row>
                <Col sm={12}>

                  <Row className="align-items-end mt-3">
                    {/* <Col sm={4} className="mr-2" style={{ marginTop: '5px', marginBottom:'30px' }}>
                      <span className={`badge badge-pill ${criticidadBadge}`} style={{ fontSize: '1rem', width: '300px', height: '30px', alignContent: 'center' }}>{rowData.criticidad_nombre}</span>
                    </Col> */}
                    <Container className="mt-4">
                      <Row className="align-items-start mb-5">
                        <Col lg={4} xs="auto" className='mt-2'>
                          <div className={`${criticidadColor} text-white text-center p-2`} style={{ fontWeight: "bold" }}>{rowData.criticidad_nombre}</div>
                          
                        </Col>
                        <Col lg={7} className="mt-2" style={{ marginRight: '30px' }}>
                          <div style={{ width: "100%" }}>
                            <table className="table table-bordered table-sm" >
                              <thead>
                                <tr>
                                  <th className='text-center' colSpan={5}>Nivel de Criticidad</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <th className={rowData.criticidad_promedio == 1 ? "bg-success" : "table-warning"} style={{ textAlign: 'center' }}>1</th>
                                  <th className={rowData.criticidad_promedio == 2 ? "bg-success" : "table-warning"} style={{ textAlign: 'center' }}>2</th>
                                  <th className={rowData.criticidad_promedio == 3 ? "bg-success" : "table-warning"} style={{ textAlign: 'center' }}>3</th>
                                  <th className={rowData.criticidad_promedio == 4 ? "bg-success" : "table-warning"} style={{ textAlign: 'center' }}>4</th>
                                  <th className={rowData.criticidad_promedio == 5 ? "bg-success" : "table-warning"} style={{ textAlign: 'center' }}>5</th>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </Col>
                      </Row>

                      <Row className='mb-4'>
                        <Container fluid>
                          {rowData.info_matriz.map((criticidad) => {
                            let tipoCriticidad = convertirPalabraAVertical(criticidad.tipo_criticidad)
                            return (
                              <Row className='mb-5'>
                                <Col sm={1} className='texto-vertical contenedor-titulos' dangerouslySetInnerHTML={{__html: tipoCriticidad}}>                                 
                                  
                                </Col>
                                <Col sm={11}>
                                  <Container className='contenedor-factores'>
                                    {criticidad.factores.map((factor) => {
                                      return (
                                        <Row>
                                          <Col className='contenedor-titulos text-center align-middle' sm={3}>
                                            {factor.factor_criticidad}
                                          </Col>
                                          <Col sm={9} style={{ paddingLeft: "6px" }}>
                                            <Container>
                                              <Row className='contenedor-factores'>
                                                {factor.factores.map((criterio) => {
                                                  return (
                                                    <Col sm={11} style={{ paddingRight: "6px" }}>
                                                      <table className="table table-bordered table-sm m-0" >
                                                        <thead>
                                                          <tr>
                                                            <th className='text-center table-primary' colSpan={5}>{criterio.factor_criterio}</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          <tr>
                                                            <th className={criterio.valor_criticidad == 1 && "bg-success"} style={{ textAlign: 'center' }}>1</th>
                                                            <th className={criterio.valor_criticidad == 2 && "bg-success"} style={{ textAlign: 'center' }}>2</th>
                                                            <th className={criterio.valor_criticidad == 3 && "bg-success"} style={{ textAlign: 'center' }}>3</th>
                                                            <th className={criterio.valor_criticidad == 4 && "bg-success"} style={{ textAlign: 'center' }}>4</th>
                                                            <th className={criterio.valor_criticidad == 5 && "bg-success"} style={{ textAlign: 'center' }}>5</th>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                    </Col>
                                                  )

                                                })}

                                              </Row>

                                            </Container>
                                          </Col>

                                        </Row>
                                      )
                                    })}
                                  </Container>
                                </Col>
                              </Row>
                            )

                          })}

                        </Container>

                      </Row>


                    </Container>
                    {/* 
                    <Col sm={3} className="mt-2" style={{ marginRight: '30px' }}>
                      <div>
                        <table className="table table-bordered" style={{ marginBottom: '-1px' }}>
                          <thead>
                            <tr>
                              <th rowSpan={'5'} style={{ textAlign: 'center' }}>Nivel de Criticidad</th>
                            </tr>
                          </thead>
                        </table>
                        <table className="table table-bordered ">
                          <tbody>
                            <tr>
                              <th className="table-warning" style={{ textAlign: 'center' }}>1</th>
                              <th className="table-warning" style={{ textAlign: 'center' }}>2</th>
                              <th className="table-warning" style={{ textAlign: 'center' }}>3</th>
                              <th className="table-warning" style={{ textAlign: 'center' }}>4</th>
                              <th className="table-warning" style={{ textAlign: 'center' }}>5</th>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </Col> */}

                  </Row>

                </Col>
              </Row>


            </Col>

            {/* Segundo Row */}
            <Col md={3}>
              <Row>
                <Col sm={3} className="mt-5" style={{ verticalAlign: 'top' }}>
                  <div>
                    <table className="table table-bordered" style={{ marginBottom: '-1px', borderColor: 'black' }}>
                      <tbody>
                        {rowData.info_matriz.map((item, index) => (
                          <tr key={index}>
                            <td className="table-primary">{item.tipo_criticidad}</td>
                            <td className="table-light">{item.criticidad_promedio.promedio}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-2 mr-2"></Col>
                <Col sm={4} className="mt-2 mr-2"></Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-2 mr-2"></Col>
                <Col sm={4} className="mt-2 mr-2"></Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-2 mr-2"></Col>
                <Col sm={4} className="mt-2 mr-2"></Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-2 mr-2"></Col>
                <Col sm={4} className="mt-2 mr-2"></Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-2 mr-2"></Col>
                <Col sm={4} className="mt-2 mr-2"></Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-2 mr-2"></Col>
                <Col sm={4} className="mt-2 mr-2"></Col>
              </Row>
              <Row>
                <Container className="chart-container position-relative">
                  {/* Titulos de los ejes */}
                  <div className="axis-title x-axis-title">Vulnerabilidad</div>
                  <div className="axis-title y-axis-title">Negocio</div>

                  <Row className="h-50">
                    <Col className="h-100 d-flex align-items-center justify-content-center border section" style={{ backgroundColor: 'yellow', fontWeight: "bold", color: "#000" }}>
                      Media Criticidad
                    </Col>
                    <Col className="h-100 d-flex align-items-center justify-content-center border section" style={{ backgroundColor: 'red', fontWeight: "bold", color: "#000" }}>
                      Alta Criticidad
                    </Col>
                  </Row>
                  <Row className="h-50">
                    <Col className="h-100 d-flex align-items-center justify-content-center border section" style={{ backgroundColor: 'lightgreen', fontWeight: "bold", color: "#000" }}>
                      Baja Criticidad
                    </Col>
                    <Col className="h-100 d-flex align-items-center justify-content-center border section" style={{ backgroundColor: 'yellow', fontWeight: "bold", color: "#000" }}>
                      Media Criticidad
                    </Col>
                  </Row>

                  {/* Líneas y etiquetas */}
                  <div className="line vertical-line" style={{ left: `${vulnerabilidadPos}%`, bottom: '0%', height: `${negocioPos}%` }} />
                  <div className="line horizontal-line" style={{ top: `${100 - negocioPos}%`, left: '0%', width: `${vulnerabilidadPos}%` }} />

                  {/* Punto de intersección */}
                  <div className="intersection-point" style={{ left: `calc(${vulnerabilidadPos}% - 5px)`, top: `calc(${100 - negocioPos}% - 5px)` }} />

                  {/* Etiquetas de los valores */}
                  <div className="axis-label" style={{ left: `${vulnerabilidadPos}%`, bottom: '-20px' }}>
                    {vulerabilidadProm}
                  </div>
                  <div className="axis-label" style={{ top: `${100 - negocioPos}%`, left: '-20px' }}>
                    {negocioProm}
                  </div>

                  {/* Etiquetas de los extremos */}
                  <div className="axis-end-label" style={{ left: '-10%', bottom: '-35px', fontWeight: "bold" }}>0</div>
                  <div className="axis-end-label" style={{ left: '100%', bottom: '-35px', fontWeight: "bold" }}>5</div>
                  <div className="axis-end-label" style={{ top: '0%', left: '-10%', fontWeight: "bold" }}>5</div>
                </Container>
                {/* <Col sm={4} className="mt-2 mr-2">
                  <div style={{ border: '1px solid black', padding: '20px', width: '300px', height: '300px' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                      <Container style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Row>
                          <Row>
                            <div style={{ border: '1px solid black', width: '80%', height: '80%' }}>
                              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
                                <div style={{ width: '50%', height: '100px', border: '1px solid black', textAlign: 'center', padding: '5px', backgroundColor: 'yellow' }}>
                                  <div style={{ marginTop: '25px' }}> Media Criticidad</div>
                                </div>
                                <div style={{ width: '50%', height: '100px', border: '1px solid black', textAlign: 'center', padding: '5px', backgroundColor: 'red' }}>
                                  <div style={{ marginTop: '25px' }}> Alta Criticidad</div>
                                </div>
                                <div style={{ width: '50%', height: '105px', border: '1px solid black', textAlign: 'center', padding: '5px', backgroundColor: 'green' }}>
                                  <div style={{ marginTop: '25px' }}> Baja Criticidad</div>
                                </div>
                                <div style={{ width: '50%', height: '105px', border: '1px solid black', textAlign: 'center', padding: '5px', backgroundColor: 'yellow' }}>
                                  <div style={{ marginTop: '25px' }}> Media Criticidad</div>
                                </div>
                              </div>
                            </div>
                          </Row>
                          <Row className='text-center'>
                              Vulnerabilidad
                          </Row>

                        </Row>

                      </Container>
                    </div>

                  </div>
                </Col> */}

              </Row>
              <Row className='mt-5'>
                <Col sm={6} className="mt-2 mr-2">
                  <span style={{ fontSize: '1rem' }}>Fecha de Evaluación:</span> <span className="badge badge-pill badge-light" style={{ fontSize: '1rem', marginLeft: '4px' }}>{moment(rowData.fecha_creacion).format('DD-MM-YYYY')}</span>
                </Col>
              </Row>
              <Row>
                <Col sm={4} className="mt-2 mr-2">
                  <span style={{ fontSize: '1rem' }}>Responsable:</span> <span className="badge badge-pill badge-light" style={{ fontSize: '1rem', marginLeft: '4px' }}>{rowData.empleado[0].nombre}</span>
                </Col>
              </Row>
            </Col>
          </Row>
        </div >

      </div >
      <ResumenEvaluacionPuestoPDF rowData={rowData} />
    </>
  )
}

export default ResumenEvaluacionPuesto;